export const searchWithCriteriaSelector = state => state.searchWithCriteriaInfo;